<script setup>
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import { computed, ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';
import axios from 'axios';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import ConfettiExplosion from 'vue-confetti-explosion';
import AlertMessage from '@/components/AlertMessage.vue';

const props = defineProps({
    importProgress: {
        type: Object,
        required: true,
    },
});

const percent = ref(props.importProgress.percent);
const sections = ref(Object.values(props.importProgress.sections));
const showConfetti = ref(false);
const color = computed(() => {
    return percent.value < 100 ? 'blue' : 'green';
});
const { pause } = useIntervalFn(() => {
    if (percent.value < 100) {
        axios.get(props.importProgress.url).then((response) => {
            const data = response.data;
            percent.value = data.percent;
            sections.value = Object.values(data.sections);

            if (percent.value > 99) {
                pause();
                showConfetti.value = true;
            }
        });
    }
}, 1000);
</script>

<template>
    <AlertMessage class="mt-5 inline-block" type="info">
        <template v-slot:title>
            {{ $t('messages.importing') }}
        </template>
        <template v-slot:body>
            {{ importProgress.message }}
        </template>
    </AlertMessage>

    <ProgressBar :percent="percent" :color="color" class="mt-3" />
    <div v-if="sections.length > 0" class="mt-3">
        <AppWell>
            <AppCard>
                <div class="p-2">
                    <ul>
                        <li v-for="section in sections" :key="`${section.text}_${section.percent}`">
                            <div>
                                {{ section.text }}
                            </div>
                            <ProgressBar :percent="section.percent" :color="section.is_finished ? 'green' : 'blue'" />
                        </li>
                    </ul>
                </div>
            </AppCard>
        </AppWell>
    </div>
    <Teleport to="body">
        <div class="relative z-20 pointer-events-none">
            <div class="fixed z-10 inset-0">
                <div class="flex items-center justify-center min-h-full p-4">
                    <ConfettiExplosion v-if="showConfetti" />
                </div>
            </div>
        </div>
    </Teleport>
</template>
